import PropTypes from 'prop-types';
import headingLevel from './src/headingLevel';
import classNameOverride from './src/classNameOverride';
export default {
  ...PropTypes,
  headingLevel,
  classNameOverride
};